<template>
    <v-text-field
        class="px-2"
        v-model="text"
        append-icon="mdi-magnify"
        label="Cautare..."
        single-line
        hide-details
    ></v-text-field>
</template>
<script>
    import debounce from 'lodash/debounce'
    import { createNamespacedHelpers } from "vuex";
    const { mapGetters } = createNamespacedHelpers("filter");
    export default {
        props: {
            value: {
                type: String,
                default () {
                    return null
                }
            }
        },
        data: function () {
            return {
                text: this.value
            }
        },
        watch: {
            text: {
                handler: debounce(function (val) {
                    this.$store.commit('filter/setSearch', val)
                    this.$emit('input', val)
                }, 1000)
            },
            value: {
                handler(val) {
                    this.text = val
                }
            }
        },
        computed: {
            ...mapGetters({
                getSearch: "getSearch"
            })
        },
        created() {
            this.text = this.getSearch(this.value)
        }
    }
</script>
